export class GetPaginationVM {
    pageIndex: number;
    pageSize: number;
    status: boolean;
}
